export var TranslationKeys;
(function (TranslationKeys) {
    TranslationKeys["VCS_ADMIN_RIGHT_PANEL_TITLE"] = "vcs.admin.rightPanel.title";
    TranslationKeys["VCS_ADMIN_MUTED_ALERT_TITLE"] = "vcs.admin.muted.alert.title";
    TranslationKeys["VCS_ADMIN_MUTED_ALERT_DESC"] = "vcs.admin.muted.alert.description";
    TranslationKeys["VCS_ADMIN_CONFIG_MODAL_TITLE"] = "vcs.admin.config.modal.title";
    TranslationKeys["VCS_ADMIN_CONFIG_MODAL_REPOSITORY_LABEL"] = "vcs.admin.config.modal.repository.label";
    TranslationKeys["VCS_ADMIN_CONFIG_MODAL_LABEL_USERNAME_LABEL"] = "vcs.admin.config.modal.username.label";
    TranslationKeys["VCS_ADMIN_CONFIG_MODAL_TOKEN_LABEL"] = "vcs.admin.config.modal.token.label";
    TranslationKeys["VCS_ADMIN_CONFIG_MODAL_REPOSITORY_PLACEHOLDER"] = "vcs.admin.config.modal.repository.url.placeholder";
    TranslationKeys["VCS_ADMIN_CONFIG_MODAL_LABEL_USERNAME_PLACEHOLDER"] = "vcs.admin.config.modal.username.placeholder";
    TranslationKeys["VCS_ADMIN_CONFIG_MODAL_TOKEN_PLACEHOLDER"] = "vcs.admin.config.modal.token.placeholder";
    TranslationKeys["VCS_ADMIN_CONFIG_MODAL_FIELD_REQUIRED"] = "vcs.admin.config.modal.field.required";
    TranslationKeys["VCS_ADMIN_CONFIG_REPO_FIELD_REQUIRED"] = "vcs.admin.config.modal.repofield.required";
    TranslationKeys["VCS_ADMIN_CONFIG_USERNAME_REQUIRED"] = "vcs.admin.config.modal.username.required";
    TranslationKeys["VCS_ADMIN_CONFIG_TOKEN_REQUIRED"] = "vcs.admin.config.modal.token.required";
    TranslationKeys["VCS_ADMIN_CONFIG_FIELDS_REQUIRED"] = "vcs.admin.config.modal.fields.required";
    TranslationKeys["VCS_ADMIN_CONFIG_MODAL_BRANCH_LABEL"] = "vcs.admin.config.modal.branch.label";
    TranslationKeys["VCS_ADMIN_CONFIG_MODAL_GUID_LABEL"] = "vcs.admin.config.modal.configuration.label";
    TranslationKeys["VCS_ADMIN_CONFIG_MODAL_VERSION_HISTORY_LABEL"] = "vcs.admin.config.modal.version.history.label";
    TranslationKeys["VCS_ADMIN_CONFIG_MODAL_BRANCH_PLACEHOLDER"] = "vcs.admin.config.modal.branch.placeholder";
    TranslationKeys["VCS_ADMIN_CONFIG_MODAL_GUID_PLACEHOLDER"] = "vcs.admin.config.modal.configuration.branch.placeholder";
    TranslationKeys["VCS_ADMIN_CONFIG_MODAL_NO_BRANCH_PLACEHOLDER"] = "vcs.admin.config.modal.no.branch.placeholder";
    TranslationKeys["VCS_ADMIN_CREATE_CONFIG_SUCCESS_MESSAGE"] = "vcs.admin.create.config.success.message";
    TranslationKeys["VCS_ADMIN_CREATE_CONFIG_FAILURE_MESSAGE"] = "vcs.admin.create.config.failure.message";
    TranslationKeys["VCS_ADMIN_RIGHT_PANEL_EDITBTN_TEXT"] = "vcs.admin.rightPanel.editBtn.text";
    TranslationKeys["VCS_ADMIN_RIGHT_PANEL_DETAILS_HEADER_LABEL"] = "vcs.admin.rightPanel.details.header.label";
    TranslationKeys["VCS_ADMIN_RIGHT_PANEL_DETAILS_VERSION_HISTORY_LABEL"] = "vcs.admin.rightPanel.details.version.history.label";
    TranslationKeys["VCS_ADMIN_RIGHT_PANEL_RESET_CONFIGURATION_LABEL"] = "vcs.admin.rightPanel.reset.configuration.label";
    TranslationKeys["VCS_ADMIN_EDIT_CONFIGURATION_WARNING_TEXT"] = "vcs.admin.edit.configuration.warning.text";
    TranslationKeys["VCS_ADMIN_CONFIG_MODAL_INVALID_CREDENTIALS"] = "vcs.admin.config.modal.credentials.error.text";
    TranslationKeys["VCS_ADMIN_EDIT_CONFIG_UPDATE_MESSAGE"] = "vcs.admin.edit.config.update.message";
    TranslationKeys["VCS_ADMIN_RIGHT_PANEL_RESET_CONFIGURATION_MODAL_TEXT"] = "vcs.admin.rightPanel.reset.configuration.modal.text";
    TranslationKeys["VCS_FILTER_SEARCH_TEXT"] = "attributeFilter.SEARCH";
    TranslationKeys["VCS_ADMIN_NO_BRANCH_ALL_ORGS_ERROR_MESSAGE"] = "vcs.admin.allorgs.noBranch.error.message";
    TranslationKeys["VCS_ADMIN_NO_BRANCH_ERROR_MESSAGE"] = "vcs.admin.org.noBranch.error.message";
    TranslationKeys["VCS_ADMIN_NO_MATCH_MSG"] = "NO_MATCH_MSG";
    TranslationKeys["VCS_ADMIN_ORG_STATUS"] = "vcs.admin.org.status.header";
    TranslationKeys["VCS_ADMIN_ORG_TABLE_COL_HEADER_NAME"] = "vcs.admin.org.name.header";
    TranslationKeys["VCS_ADMIN_ORG_ENABLE_VERSION_CONTROL"] = "vcs.admin.org.config.enable.text";
    TranslationKeys["VCS_ADMIN_ORG_RESET_CONFIG_TEXT"] = "vcs.admin.org.config.reset.text";
    TranslationKeys["VCS_ADMIN_RESET_SUCCESS_ALERT_TEXT"] = "vcs.admin.reset.success.alert.text";
    TranslationKeys["VCS_ADMIN_GUID_NO_BRANCH_ERROR"] = "vcs.admin.org.guid.noBranch.error.message";
    TranslationKeys["VCS_ADMIN_GUID_NO_BRANCH_ALL_ORG_ERROR"] = "vcs.admin.allorgs.guid.noBranch.error.message";
    TranslationKeys["VCS_RETRY"] = "error.retry";
    TranslationKeys["VCS_CONTACT_SUPPORT"] = "vcs.version.history.contact.support";
    TranslationKeys["VCS_SOMETHING_WENT_WRONG_ERROR"] = "vcs.version.history.common.error";
})(TranslationKeys || (TranslationKeys = {}));
export var ModalActions;
(function (ModalActions) {
    ModalActions["CONFIRM"] = "CONFIRM";
    ModalActions["CANCEL"] = "CANCEL";
})(ModalActions || (ModalActions = {}));
export var ALLORG;
(function (ALLORG) {
    ALLORG["ID"] = "-1";
    ALLORG["NAME"] = "ALL-ORG";
    ALLORG["TEMPID"] = "-2";
})(ALLORG || (ALLORG = {}));
export var Mode;
(function (Mode) {
    Mode["EDIT"] = "edit";
    Mode["VIEW"] = "view";
})(Mode || (Mode = {}));
export var DetailsConstant;
(function (DetailsConstant) {
    DetailsConstant["ENABLED"] = "Enabled";
    DetailsConstant["DISABLED"] = "Disabled";
    DetailsConstant["EMPTYDATA"] = "-";
})(DetailsConstant || (DetailsConstant = {}));
export var ConfigModalStepsTitle;
(function (ConfigModalStepsTitle) {
    ConfigModalStepsTitle["STEP1TITLE"] = "Enter Github Credentials";
    ConfigModalStepsTitle["STEP2TITLE"] = "Select Branch";
})(ConfigModalStepsTitle || (ConfigModalStepsTitle = {}));
//# sourceMappingURL=constant.js.map